export function CreditsIcon(props) {
  return (
    <svg fill="none" height={53} viewBox="0 0 52 53" width={52} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_748_10539)">
        <path
          d="M12 2H40C45.2467 2 49.5 6.25329 49.5 11.5V39.5C49.5 44.7467 45.2467 49 40 49H12C6.7533 49 2.5 44.7467 2.5 39.5V11.5C2.5 6.2533 6.75329 2 12 2Z"
          shapeRendering="crispEdges"
          stroke="#EAECF0"
        />
        <path
          d="M18.5 35.5V30.5M18.5 20.5V15.5M16 18H21M16 33H21M27 16.5L25.2658 21.0089C24.9838 21.7421 24.8428 22.1087 24.6235 22.4171C24.4292 22.6904 24.1904 22.9292 23.9171 23.1235C23.6087 23.3428 23.2421 23.4838 22.5089 23.7658L18 25.5L22.5089 27.2342C23.2421 27.5162 23.6087 27.6572 23.9171 27.8765C24.1904 28.0708 24.4292 28.3096 24.6235 28.5829C24.8428 28.8913 24.9838 29.2579 25.2658 29.9911L27 34.5L28.7342 29.9911C29.0162 29.2579 29.1572 28.8913 29.3765 28.5829C29.5708 28.3096 29.8096 28.0708 30.0829 27.8765C30.3913 27.6572 30.7579 27.5162 31.4911 27.2342L36 25.5L31.4911 23.7658C30.7579 23.4838 30.3913 23.3428 30.0829 23.1235C29.8096 22.9292 29.5708 22.6904 29.3765 22.4171C29.1572 22.1087 29.0162 21.7421 28.7342 21.0089L27 16.5Z"
          stroke="url(#paint0_linear_748_10539)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height={52}
          id="filter0_d_748_10539"
          width={52}
          x={0}
          y={0.5}
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_748_10539" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_748_10539" mode="normal" result="shape" />
        </filter>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_748_10539"
          x1={15.9997}
          x2={35.9998}
          y1={35.4999}
          y2={15.4998}
        >
          <stop stopColor="#FF6C6C" />
          <stop offset={1} stopColor="#DD7BFF" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function StarterPackIcon(props) {
  return (
    <svg fill="none" height={33} viewBox="0 0 32 33" width={32} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5Z"
        fill="#FCE7F6"
      />
      <path
        d="M15.9987 23.1673C19.6806 23.1673 22.6654 20.1826 22.6654 16.5007C22.6654 12.8188 19.6806 9.83398 15.9987 9.83398C12.3168 9.83398 9.33203 12.8188 9.33203 16.5007C9.33203 20.1826 12.3168 23.1673 15.9987 23.1673Z"
        stroke="#EB3EB7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.33333}
      />
      <path
        clipRule="evenodd"
        d="M15.9964 14.5459C15.33 13.7668 14.2186 13.5572 13.3836 14.2707C12.5486 14.9841 12.431 16.177 13.0868 17.0208C13.5068 17.5612 14.5824 18.5635 15.3015 19.2142C15.5405 19.4305 15.66 19.5386 15.8031 19.582C15.9261 19.6192 16.0667 19.6192 16.1897 19.582C16.3329 19.5386 16.4523 19.4305 16.6913 19.2142C17.4104 18.5635 18.4861 17.5612 18.9061 17.0208C19.5618 16.177 19.4586 14.9766 18.6092 14.2707C17.7599 13.5647 16.6629 13.7668 15.9964 14.5459Z"
        fillRule="evenodd"
        stroke="#EB3EB7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.33333}
      />
    </svg>
  )
}

export function ProPackIcon(props) {
  return (
    <svg fill="none" height={33} viewBox="0 0 32 33" width={32} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5Z"
        fill="#FCE7F6"
      />
      <path
        d="M15.9987 9.83398L18.3987 12.234C19.9987 8.03398 24.4654 12.5007 20.2654 14.1007L22.6654 16.5007L20.2654 18.9007C18.6654 14.7007 14.1987 19.1673 18.3987 20.7673L15.9987 23.1673L13.5987 20.7673C11.9987 24.9673 7.53203 20.5007 11.732 18.9007L9.33203 16.5007L11.732 14.1007C13.332 18.3007 17.7987 13.834 13.5987 12.234L15.9987 9.83398Z"
        stroke="#EB3EB7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.33333}
      />
    </svg>
  )
}

export function MegaPackIcon(props) {
  return (
    <svg fill="none" height={33} viewBox="0 0 32 33" width={32} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5Z"
        fill="#FCE7F6"
      />
      <path
        d="M16.0013 18.5008L14.0013 16.5008M16.0013 18.5008C16.9325 18.1466 17.8259 17.7 18.668 17.1675M16.0013 18.5008V21.8341C16.0013 21.8341 18.0213 21.4675 18.668 20.5008C19.388 19.4208 18.668 17.1675 18.668 17.1675M14.0013 16.5008C14.3561 15.5804 14.8028 14.6982 15.3346 13.8675C16.1114 12.6255 17.1931 11.6028 18.4766 10.8969C19.7602 10.1909 21.2031 9.82506 22.668 9.83415C22.668 11.6475 22.148 14.8341 18.668 17.1675M14.0013 16.5008H10.668C10.668 16.5008 11.0346 14.4808 12.0013 13.8341C13.0813 13.1141 15.3346 13.8341 15.3346 13.8341M11.0013 19.5008C10.0013 20.3408 9.66797 22.8341 9.66797 22.8341C9.66797 22.8341 12.1613 22.5008 13.0013 21.5008C13.4746 20.9408 13.468 20.0808 12.9413 19.5608C12.6822 19.3135 12.3408 19.1706 11.9828 19.1595C11.6247 19.1484 11.2752 19.27 11.0013 19.5008Z"
        stroke="#EB3EB7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.33333}
      />
    </svg>
  )
}
